export default {"src":"/_next/static/media/doggo_happy_gray.35fc8dc5.svg","height":53,"width":41};